import React from "react";
import dayjs from "dayjs";
import SubmittedDetails from "../../../Core/Components/SubmittedDetails";
import getStatus from "../Common/getStatus";
import { CONTAINER_STATUS, CONTAINER_TYPE } from ".";
import getType from "../Common/getType";
import ListDropdown from "../ListDropdown";

export const columns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Container ID
      </div>
    ),
    dataIndex: "containerName",
    sorter: (a, b) => a?.containerName?.localeCompare(b?.containerName),
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-black capitalize">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Container Type
      </div>
    ),
    dataIndex: "type",
    sorter: (a, b) => a.type - b.type,
    render: (text) => <div>{getType(text)}</div>,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Permanent Hub Station
      </div>
    ),
    dataIndex: "permanentHubName",
    sorter: (a, b) => a?.permanentHubName?.localeCompare(b?.permanentHubName),
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Current Association
      </div>
    ),
    dataIndex: "currentHubName",
    sorter: (a, b) => a?.currentHubName?.localeCompare(b?.currentHubName),
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Status
      </div>
    ),
    dataIndex: "status",
    sorter: (a, b) => a.status - b.status,
    render: (text) => <div>{getStatus(+text)}</div>,
  },
  {
    title: () => (
      <div className="font-light font-poppins text-10 text-dark-gray">
        Date of Entry
      </div>
    ),
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    dataIndex: "submittedAt",
    width: "200px",
    render: (text, record) => <SubmittedDetails record={record} />,
  },
  {
    dataIndex: "id",
    width: "5%",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];

export const containerData = [
  {
    id: 1,
    containerId: "CR-1000",
    type: CONTAINER_TYPE.CRATE,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.HUB_STATION,
    submittedAt: dayjs(),
  },
  {
    id: 2,
    containerId: "CR-1001",
    type: CONTAINER_TYPE.CRATE,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.ON_A_TRIP,
    submittedAt: dayjs(),
  },
  {
    id: 3,
    containerId: "CR-1003",
    type: CONTAINER_TYPE.CANISTER,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.HUB_STATION,
    submittedAt: dayjs(),
  },
  {
    id: 4,
    containerId: "CR-1004",
    type: CONTAINER_TYPE.CANISTER,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.ON_A_TRIP,
    submittedAt: dayjs(),
  },
  {
    id: 5,
    containerId: "CR-1005",
    type: CONTAINER_TYPE.CRATE,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.ON_A_TRIP,
    submittedAt: dayjs(),
  },
  {
    id: 6,
    containerId: "CR-1006",
    type: CONTAINER_TYPE.CANISTER,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.HUB_STATION,
    submittedAt: dayjs(),
  },
  {
    id: 7,
    containerId: "CR-1007",
    type: CONTAINER_TYPE.CRATE,
    permanentHubStationId: 14,
    permanentHubStationName: "Kilgoris Agr-e-hub",
    currentAssociationId: 15,
    currentAssociationName: "Magena Agr-e-hub",
    status: CONTAINER_STATUS.ON_A_TRIP,
    submittedAt: dayjs(),
  },
];
